// extracted by mini-css-extract-plugin
export default {"resultListContainer":"ResultList_resultListContainer__W59OD","isDualModeLauncher":"ResultList_isDualModeLauncher__B3dGU"};